// src/client/components/ScreenShell.tsx
// Per-screen container. Encapsulates the top header (title + optional back
// button) and the scrollable content area. Pass `withNav={false}` for auth
// screens that hide the floating nav.
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './ScreenShell.module.css';
import '@client/styles/layout.css';

interface Props {
  title?: ReactNode;
  back?: boolean;
  rightSlot?: ReactNode;
  children: ReactNode;
  withNav?: boolean;
}

export default function ScreenShell({ title, back, rightSlot, children, withNav = true }: Props) {
  const navigate = useNavigate();
  const shellCls = ['app-shell', withNav && 'app-shell--with-nav'].filter(Boolean).join(' ');
  return (
    <div className={shellCls}>
      {(title || back || rightSlot) && (
        <header className={styles.header}>
          {back ? (
            <button
              className={styles.back}
              onClick={() => navigate(-1)}
              aria-label="Go back"
              type="button"
            >
              <ChevronLeft size={22} aria-hidden />
            </button>
          ) : <span className={styles.spacer} />}
          <div className={styles.title}>{title}</div>
          <div className={styles.right}>{rightSlot}</div>
        </header>
      )}
      <main className="scroll-area">{children}</main>
    </div>
  );
}
